<template>
    <CreateTest
            :appName="appName"
            :platform="platform"
            :appIcon="appIcon"
            :appKey="appKey"
            :hasMissingConfigs="hasMissingConfigsComputed"
            @createTestClick="$emit('createTestClick', $event)"
    ></CreateTest>
</template>

<script>
import externalPropsParser from 'services/utils/externalPropsParser';
import externalParsedProps from '@/mixins/externalParsedProps';
import CreateTest from '@/pages/monetize/abTest/CreateTest.vue';
import eventBus from '@/mixins/eventBus';

const parsedProps = ['hasMissingConfigs'];

export default {
    name: 'CreateTestEx',
    mixins: [
        eventBus('create-test-ex'),
        externalParsedProps(CreateTest.props, parsedProps)
    ],
    props: externalPropsParser.setExternalProps(CreateTest.props, parsedProps),
    components: { CreateTest }
};
</script>
